import { axiosTokenRequests, axiosNoTokenRequests } from "../config.api";
import { getAuthUser } from "../../services/Authentication/AuthenticationService";
import {
  IAuthUser,
  IAuthResponse,
} from "../../models/Authentication/Authentication.models";

const AuthAPIService = {
  authenticate: (body: IAuthUser): Promise<IAuthResponse> =>
    axiosNoTokenRequests.post("/auth/authenticate", body),
  refreshToken: (refreshToken: string): Promise<IAuthResponse> =>
    axiosNoTokenRequests.post("/auth/refresh-token", { refreshToken }),
  logout: (): Promise<IAuthResponse> =>
    axiosTokenRequests.post("/auth/logout", {
      refreshToken: getAuthUser().user?.refreshToken ?? "",
    }),
};

export { AuthAPIService };
